import { config as _config } from './config.dev';
export const config:any ={
    ..._config
};